module.exports = __webpack_public_path__ + "img/0S6A0103.be44ec37.jpg";